import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { environment } from "../../environments/environment";
import { ApiService } from "./api.service";

export interface CreateAction {
    createdBy?: string;
    actionType: number;
    status: number;
    title: string;
    description: string;
    source: string;
}

@Injectable({ providedIn: "root" })
export class ActionService {
    constructor(private apiService: ApiService, private http: HttpClient) { }
    createActionFromBespokeRequest(params: {
        action: CreateAction;
        bespokeFormId: number;
    }) {
        return this.http
            .post(
                environment.apiPath + "actions/from-bespoke",
                params,
                this.apiService.getHttpOptions()
            )
            .pipe(
                catchError(this.apiService.handleError.bind(this.apiService))
            );
    }
    public getActionTypes(): Observable<any> {
        return this.http
            .get(
                environment.apiPath + `actions/types`,
                this.apiService.getHttpOptions()
            )
            .pipe(map((result: any) => result.data));
    }
    public getActionTypesByType(type): Observable<any> {
        return this.http
            .get(
                environment.apiPath + `actions/types/${type}`,
                this.apiService.getHttpOptions()
            )
            .pipe(map((result: any) => result.data));
    }
}
